import React, { useState, MouseEvent } from "react";
import DownloadButton from "ui-components/download-button/downloadButton";
import { toast } from "react-toastify";
import { downloadEquipmentBadge } from "../utils/downloadEquipmentBadge";

export interface EquipmentBadgeDownloadButtonProps {
  unitNumber: string | null | undefined;
  equipmentType: string | null | undefined;
  terminalLabel?: string | null;
}

const EquipmentBadgeDownloadButton: React.FC<EquipmentBadgeDownloadButtonProps> = ({
  unitNumber,
  equipmentType,
  terminalLabel,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (!unitNumber?.trim() || isDownloading) return;

    setIsDownloading(true);
    try {
      await downloadEquipmentBadge({
        unitNumber,
        equipmentType: equipmentType || "",
        terminalLabel: terminalLabel || "",
      });
    } catch {
      toast.error("Unable to download equipment badge");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <DownloadButton
      title="Download Badge"
      onClick={handleDownload}
      spinner={isDownloading}
      disabled={!unitNumber?.trim() || isDownloading}
    />
  );
};

export default EquipmentBadgeDownloadButton;
